module.exports = __webpack_public_path__ + "img/Nachtrag.ac85bd8a.svg";